import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-backdrop"
}
const _hoisted_2 = { class: "modal-docusign" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "header-title" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = {
  key: 0,
  class: "spinner-container"
}
const _hoisted_8 = { class: "loading-text" }
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('devis.modal.docusign.title', { id: _ctx.devisNumero })), 1),
            _createElementVNode("img", {
              class: "close-icon",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
              src: _ctx.closeIcon,
              alt: "close"
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_LoaderComponent),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('devis.modal.docusign.loading')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.url)
              ? (_openBlock(), _createElementBlock("iframe", {
                  key: 1,
                  src: _ctx.url,
                  class: "docusign-iframe",
                  onLoad: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onIframeLoaded && _ctx.onIframeLoaded(...args))),
                  allow: "camera; microphone; geolocation"
                }, null, 40, _hoisted_9))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}